import { styles } from "@repo/helpers";

import { LocationStatusEnum } from "../../models";
import style from "./style.module.scss";

export function StatusDot({ statusId }: { statusId: number }) {
	function getStatusColor(statusId: number) {
		if (statusId === LocationStatusEnum.Active) return style.green;
		if (
			statusId === LocationStatusEnum.Inactive ||
			statusId === LocationStatusEnum.RoEDenied ||
			statusId === LocationStatusEnum.RoERevoked
		)
			return style.red;
		if (statusId === LocationStatusEnum.Suspended) return style.orange;
		return style.yellow;
	}
	return <div className={styles(style.timelineDot, getStatusColor(statusId))} />;
}
